import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DimensionBar from './components/DimensionBar';
import Content from './components/Content';
import { DefaultParams } from '../constants/dimension';

class DimensionAnalysis extends Component {
    static contextTypes = {
        moduleType: PropTypes.string,
        activeKey: PropTypes.string,
        business: PropTypes.array,
        handleExpand: PropTypes.func,
    }

    constructor(props, context) {
        super(props);
        const { source,selectParams } = props;
        const { moduleType, activeKey } = context;
        this.state = {
            params: selectParams?
            {moduleType,...selectParams}:{
                moduleType,
                ...DefaultParams[source][activeKey]
            }
        };
    }

    handleChange = (params) => {
        this.setState({ params: {...params} });
    }

    render() {
        const { business, handleExpand } = this.context;
        const { params } = this.state;
        const{financeIndicatorAnalysis,projectIndicatorAnalysis,personIndicatorAnalysis}=this.props;//财务指标分析/项目指标分析菜单页权限
        return (
            <div>
                <DimensionBar
                    business={business}
                    params={params}
                    onExpand={handleExpand}
                    onChange={this.handleChange}
                    financeIndicatorAnalysis={financeIndicatorAnalysis} 
                    projectIndicatorAnalysis={projectIndicatorAnalysis}
                    personIndicatorAnalysis={personIndicatorAnalysis} 
                />
                <Content params={params} />
            </div>
        );
    }
}

export default DimensionAnalysis;



// WEBPACK FOOTER //
// ./src/components/homePage/DimensionAnalysis/index.js